import { gql } from '@apollo/client';

export const UPDATE_USER_GROUP = gql`
  mutation updateUserGroup($input: UpdateUserGroupInput!) {
    updateUserGroup(updateUserGroupInput: $input) {
      success
      error
      userGroup {
        id
        name
        displayColour
        cognitoGroupName
        permissions {
          id
          name
          code
          scope
        }
      }
    }
  }
`;
